export default __webpack_public_path__ + "static/media/ram-min.e9f03489.png";